// fix this
import Cookies from 'cookie-universal';
import { getCookieObject, getSessionValue } from './utils.js';
import Tracking from './Tracking.js';

// Features object format
// let features = {
//     "feature name": {
//         name: "feature name",
//         value: "on",
//         experimentId: experimentId,
//         variantId: variantId
//     }
// };

const cookieName = 'ARTICLE_EXPERIMENT_V2';
const cookiePreviewName = 'ARTICLE_EXPERIMENT_V2_PREVIEW';
const cookiePreviewFeatureName = 'ARTICLE_EXPERIMENT_V2_FEATURES_PREVIEW';

export const ALWAYS_OPEN_MOBILE_SEARCH = 'always-open-search-mobile';
export const FEATURES_ICONS = 'features-icons';

export default class FeatureFlag {
  static initialized = false;

  static features = {};

  static hasCookiePreview = null;

  static hasCookieFeaturePreview = null;

  static sentEvents = {};

  static initFeatures() {
    const geoGroupId = getSessionValue('geoGroupId');
    if (geoGroupId) {
      this.trackGroupId(geoGroupId);
    }

    if (FeatureFlag.hasCookiePreview === null || FeatureFlag.hasCookieFeaturePreview === null) {
      FeatureFlag.hasCookiePreview = !!Cookies().get(cookiePreviewName) || !!Cookies().get(cookiePreviewFeatureName);
      FeatureFlag.hasCookieFeaturePreview = !!Cookies().get(cookiePreviewFeatureName);
    }

    const featuresObject = Cookies().get(cookiePreviewFeatureName) ? getCookieObject(cookiePreviewFeatureName) : getCookieObject(cookieName);

    const keys = Object.keys(featuresObject);
    if (keys && keys.length) {
      // eslint-disable-next-line no-restricted-syntax
      for (const name of keys) {
        const [value, experimentId, variantId] = featuresObject[name].split('-');
        this.features[name] = {
          name,
          value,
          experimentId,
          variantId,
        };
        this.addExperimentEvent(this.features[name]);
      }
    }

    this.initialized = true;
  }

  /**
   * Check the variant for each feature
   * @param {String} feature
   */
  static getFeature(feature) {
    if (!feature) {
      return {};
    }

    if (!this.initialized) {
      this.initFeatures();
    }

    if (feature in this.features) {
      this.trackExperimentEvent(this.features[feature]);
      return this.features[feature];
    }

    return {};
  }

  /**
   * Check the feature's variant, always returns true if in dev or UAT environment
   * @param {String} feature      The feature key you get from Megamind Experiment page
   * @param {any} expectedVariant The expected variant value for this feature
   * @returns {boolean}
   */
  static checkFeatureVariant(feature, expectedVariant) {
    if (!feature) {
      return false;
    }

    if (!this.initialized) {
      this.initFeatures();
    }

    if (!FeatureFlag.hasCookieFeaturePreview && (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'uat')) {
      return true;
    }

    if (feature in this.features) {
      this.trackExperimentEvent(this.features[feature]);
      return this.features[feature].value === expectedVariant;
    }

    return false;
  }

  static addExperimentEvent({
    name, value, experimentId, variantId,
  }) {
    if (!experimentId || !variantId || this.hasCookiePreview) {
      return;
    }

    const expKey = `exp-${experimentId}`;
    const varKey = `var-${variantId}`;

    Tracking.heapAddEventProperties({
      [expKey]: varKey,
      [name]: value,
    });
  }

  static trackExperimentEvent({
    name, value, experimentId, variantId,
  }) {
    if (this.hasCookiePreview || this.sentEvents[experimentId]) {
      return;
    }

    Tracking.track('Experiment', {
      'Experiment ID': experimentId,
      'Experiment Variant ID': variantId,
      'Experiment Feature Name': name,
      'Experiment Feature Value': value,
    });

    this.sentEvents[experimentId] = true;
  }

  static trackGroupId(id) {
    Tracking.heapAddEventProperties({
      'article-group-id': id,
    });
  }
}
